import React from 'react'
const { AttentionBox } = require('monday-ui-react-core')

export const ErrorMessage = ({ error, title }) => {
  return (
    <section className="error-message">
      <AttentionBox className="monday-style-attention-box_box" text={error} title={title} />
    </section>
  )
}
